import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "move-panel",
  templateUrl: "./move-panel.component.html",
  styleUrls: ["./move-panel.component.scss"],
})
export class MovePanelComponent implements OnInit {
  @Input()
  codeName;

  @Input()
  customerGroups;

  @Input()
  codesSelected;

  @Output() moveEvent = new EventEmitter();

  selectedGroup;

  constructor() {}

  ngOnInit() {}

  moveBtnClicked() {
    this.moveEvent.emit(this.selectedGroup);
  }

  getCodesSelected() {
    if (this.codesSelected) {
      return this.codesSelected;
    } else {
      return "0";
    }
  }
}
